// Simulation step constants
export const FIRST_STEP = 'FIRST_STEP';
export const SECOND_STEP = 'SECOND_STEP';
export const THIRD_STEP = 'THIRD_STEP';
export const FOURTH_STEP = 'FOURTH_STEP';

// Animation constants
export const COLOR_UPDATE_INTERVAL_MS = 25;
export const MAX_COLOR_VALUE = 255;

// Room diagram colors
export const COLORS = {
  primary: '#0B75BD',
  danger: 'red',
  ground: '#34A56F',
  text: {
    gray: 'gray',
  },
};
